/**
 * Servicio de Consultas — solo lectura.
 *
 * Reutiliza los endpoints existentes de reportes y listas.
 * Solo agrega la llamada a /consultas/tickets-sorteo (endpoint nuevo mínimo).
 */

import { fetchAPI } from '../../../services/apiClient';

// Re-export types from reportesService for convenience
export type {
  ReporteResponse,
  ReporteSorteo,
  ReporteTotales,
  LocalOption,
  SorteoDelDia,
} from '../../../services/reportesService';

export {
  fetchReportePorSorteo,
  fetchLocalesReporte,
  fetchSorteosDelDia,
} from '../../../services/reportesService';

// --- Listas consolidada (reutiliza endpoint existente) ---

export async function fetchListaConsolidada(
  sorteoId: string,
  fecha: string,
  localId?: string,
): Promise<any[]> {
  const params = new URLSearchParams({ fecha });
  if (localId) params.append('local_id', localId);
  return fetchAPI<any[]>(`/listas/consolidada/${sorteoId}?${params.toString()}`);
}

// --- Tickets por sorteo (endpoint nuevo de consultas) ---

export interface TicketJugada {
  num1: string;
  num2: string;
  monto: string;
}

export interface TicketDetalle {
  ticket_number: string;
  fecha_operativa: string | null;
  created_at: string | null;
  local_nombre: string;
  monto: string;
  jugadas: TicketJugada[];
}

export interface TicketsSorteoResponse {
  tickets: TicketDetalle[];
  total: string;
}

export async function fetchTicketsSorteo(
  sorteoId: string,
  fecha: string,
  localId?: string,
): Promise<TicketsSorteoResponse> {
  const params = new URLSearchParams({ sorteo_id: sorteoId, fecha });
  if (localId) params.append('local_id', localId);
  return fetchAPI<TicketsSorteoResponse>(`/consultas/tickets-sorteo?${params.toString()}`);
}
